import { take } from 'rxjs/operators';

/**
 * Create a new observable that emits the most recent value from the given observable and completes.
 * This works like an observable-creator version of the withLatestFrom operator.
 */
export const latest = (hotObservable$) => hotObservable$.pipe(take(1));
